import OnlyPublicRoute from './OnlyPublicRoute';
import PrivateActiveRoute from './PrivateActiveRoute';
import PrivateRoute from './PrivateRoute';
import PublicRoute from './PublicRoute';

const ROUTES = {
  LOGIN: '/auth/login',
  FORGOT_PASSWORD: '/auth/forgot-password',
  RESET_PASSWORD: '/auth/reset-password/:token?',
  PROFILE: '/user/edit',
  USERS: '/users',
  BOOKSELLERS: '/booksellers',
  ROLLOUTS: '/rollouts',
  ROLLOUTS_BOOKS: '/rollouts-books',
  AGENT_OBJECTIVES: '/agent-objectives',
  AGENTS_BOOKSELLERS_DETAILS: '/agents-booksellers-details',
  AGENTS_BOOKSELLERS_PUBLISHERS: '/agents-booksellers-publishers',
  AGENTS_PERFOMANCE: '/agents-perfomance',
  AGENTS_PERFOMANCES_ALL: '/agents-perfomances-all',
  HOME: '/',
  OVER_DISCOUNTS: '/overDiscounts',
};

export {
  OnlyPublicRoute,
  PrivateActiveRoute,
  PrivateRoute,
  PublicRoute,
  ROUTES,
};
